import SwitchIcon from './switchIcon'
export default SwitchIcon
